import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'
import { useLazyQuery } from '@apollo/react-hooks'

import Form from '../forms/layout-form'
import Row from '../forms/layout-row'
import Col from '../forms/layout-column'
import PinInput from '../forms/pin-input'
import Button from '../button'
import { FORM_VALUES, PIN_RULES } from '../../constants'
import VALIDATE_PIN_QUERY from '../../../graphql/queries/validate-pin.gql'

function CheckPinForm({
  onValidPin,
  onCancel
}) {
  const [pin, setPin] = useState()
  const [errorMessage, setErrorMessage] = useState({})
  const [validatePin, { loading: validationLoading, data: validateData, error: validateError }] = useLazyQuery(VALIDATE_PIN_QUERY)

  useEffect(() => {
    if (!validationLoading && validateData?.validatePin) {
      setTimeout(() => onValidPin(pin), 500)
      reset()
      return
    }

    if (validateData?.validatePin === false) {
      setErrorMessage({ pin: 'Incorrect PIN' })
    }
  }, [validateData, validateError, validationLoading])

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting }
  } = useForm({
    defaultValues: {
      pin: ''
    },
    mode: 'onChange'
  })

  const onSubmit = async (values) => {
    setErrorMessage({})
    setPin(values.pin)

    validatePin({
      variables: {
        pin: values.pin,
        _nonce: Date.now()
      },
      fetchPolicy: 'network-only'
    })
  }

  const onCancelClick = () => {
    reset()
    onCancel(false)
  }

  return (
    <Form isSubmitting={isSubmitting} handleSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col>
          <Controller
            name="pin"
            control={control}
            rules={PIN_RULES}
            render={({ field }) => (
              <PinInput
                label="PIN"
                name={field.name}
                value={field.value}
                onChange={(e) => {
                  field.onChange(e)

                  if (errorMessage?.pin) {
                    setErrorMessage({})
                  }
                }}
                onBlur={field.onBlur}
                warning={errors?.pin?.message || errorMessage?.pin}
                maxLength={`${FORM_VALUES.pin.length}`}
                isValid={
                  !errorMessage?.pin &&
                  Boolean(
                    field.value && touchedFields?.pin && !errors.pin
                  )
                }
              />
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            disabled={isSubmitting}
            text="OK"
            lightBGPrimary
          />
        </Col>
        <Col>
          <Button
            disabled={isSubmitting}
            text="Cancel"
            onClick={onCancelClick}
            secondary
          />
        </Col>
      </Row>
    </Form>
  )
}

CheckPinForm.propTypes = {
  onValidPin: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default CheckPinForm
